import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Breakpoint } from "@mui/material";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/store";
import { isGovernemnt } from "../../util/form/form";
import { ButtonTextGrid } from "../..";

interface Props {
    title: string;
    handleClose: () => void;
    open: boolean;
    children: any;
    size: false | Breakpoint | undefined;
    handleSubmit?: () => void;
    buttonName?: string;
}

export default function FormDialog(props: Props) {
    const { isLoading } = useSelector((state: IRootState) => state.isLoading);
    const { user } = useSelector((state: IRootState) => state.userAuth);
    const isGovernmentRole = isGovernemnt(user?.token?.role_id as number);

    return (
        <Dialog
            open={props.open}
            onClose={props.handleClose}
            fullWidth={true}
            maxWidth={props.size}
            
        >
            <DialogTitle>{props.title}</DialogTitle>
            <DialogContent>{props.children}</DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>
                    <ButtonTextGrid>
                    取消
                    </ButtonTextGrid>
</Button>

                {isGovernmentRole ? (
                    <></>
                ) : props.handleSubmit ? (
                    <Button onClick={props.handleSubmit} disabled={isLoading}>
     <ButtonTextGrid>
                        {props.buttonName || "提交"}
     </ButtonTextGrid>


                    </Button>
                ) : (
                    <></>
                )}
            </DialogActions>
        </Dialog>
    );
}
